import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { type OrderType } from 'legacy/sections/orders/utils/orders.types'
import { Breadcrumb } from 'legacy/components/Breadcrumbs'

interface Props {
  orderType: OrderType
}

export const OrdersBreadcrumbsOrderType: FunctionComponent<Props> = ({ orderType }) => {
  if (orderType === 'delivery') {
    return (
      <Breadcrumb>
        <FormattedMessage id="delivery.title" />
      </Breadcrumb>
    )
  }

  if (orderType === 'pickup') {
    return (
      <Breadcrumb>
        <FormattedMessage id="pickup.title" />
      </Breadcrumb>
    )
  }

  if (orderType === 'scan_and_pay') {
    return (
      <Breadcrumb>
        <FormattedMessage id="scanandpay.title" />
      </Breadcrumb>
    )
  }

  throw new Error(`Unknown order type ${orderType}`)
}
